import React from 'react'
import { Theme, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { IPostElementProps } from '../../../../../types/types'
import detectFormatLinks from '../../../../../../util/detectFormatLinks'
import { getYTId, matchSocialNetworkUrl } from '../../../../../../util/matchSocialNetworkUrl'

const TextPreview: React.FC<IPostElementProps> = (props) => {
  const useStyles = makeStyles((theme: Theme) => ({
    root: {
      padding: '0 13px 25px',
      wordBreak: 'break-word',

      '& a': {
        color: theme.palette.primary.main
      }
    },
    embedResponsive: {
      position: 'relative',
      display: 'block',
      width: '100%',
      padding: '56.25% 0 0 0',
      overflow: 'hidden',
    },
    embedResponsiveItem: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      width: '100%',
      height: '100%',
      border: 0,
    },
  }))
  const classes = useStyles()
  const matched = matchSocialNetworkUrl(props.value)

  return (
    <>
      {matched
        ? (
          <div className={classes.embedResponsive}>
            <iframe
              className={classes.embedResponsiveItem}
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              srcDoc={`<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/${getYTId(props.value)}?autoplay=1><img src=https://img.youtube.com/vi/${getYTId(props.value)}/hqdefault.jpg alt=''><span>▶</span></a>`}
              allowFullScreen
            />
          </div>
        )
        : (
          <div className={classes.root}>
            {props.value.split('\n').map((str: string, index: number) => {
              if (!str) return <br key={index} />
              return (
                <Typography
                  key={index}
                  sx={{ mt: 1 }}
                  variant='body2'
                  dangerouslySetInnerHTML={{
                    __html: detectFormatLinks(str || ''),
                  }}
                />
              )
            })}
          </div>
        )}
    </>
  )
}

export default TextPreview
